import request from '@/utils/request'




// 新增联系信息收集
export function addContactPage(data) {
  return request({
    url: '/internal/contactPage',
    method: 'post',
    data: data
  })
}